<template>
    <div class="info-block">
        <div class="info-line">
            <LockIcon class="icon" />
            <p class="info-text">{{ $t(`customInfoBlock.${step}.lineOne`) }}</p>
        </div>

        <div class="info-line">
            <CreditScoreIcon />
            <p class="info-text">{{ $t(`customInfoBlock.${step}.lineTwo`) }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['step'],
}
</script>

<style lang="scss" scoped>
.info-block {
    padding: 0 25px;
    margin-bottom: 20px;

    .info-line {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .icon {
            min-width: 25px;
        }

        .info-text {
            margin-bottom: 0;
            margin-left: 10px;
            text-align: left;
        }
    }
}
</style>
